import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import ParsedPermission from "models/system-admin/parsed-permission";
import RolePermissions from "models/system-admin/role-permissions";
import User from "models/system-admin/user";
import { BasePage } from "pages/base-page";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { StateManagementService } from "../state-management/state-management.service";

@Injectable()
export class RolesService extends BasePage {
  baseEmployeeActivityUrl: string;
  searchEndpoint: string;

  constructor(
    public http: HttpClient,
    public stateData: StateManagementService,
    config: ConfigurationService
  ) {
    super(stateData);
    this.baseEmployeeActivityUrl =
      config.getConfig().apiUrl + "/roles-permissions";
    this.searchEndpoint = this.baseEmployeeActivityUrl + "/search";
  }

  getUsersRoles(request: any) {
    return this.http.post(this.searchEndpoint, request);
  }

  formatRolePermissions(hits: any): RolePermissions[] {
    let rolePermission: RolePermissions[] = [];
    if (hits.length) {
      rolePermission = hits.map((i) => {
        i.collapse = true;
        const permissions = i.permissions;
        let transformedPermissions: ParsedPermission[] = [];
        if (permissions) {
          permissions.map((p) => {
            let splitted = p.split(":");
            transformedPermissions.push({
              name: splitted[splitted.length - 1].endsWith("*")
                ? p.substring(0, p.length - 1)
                : p,
              hasAccess: true,
              module: "",
            });
          });
        }
        return { ...i, permissions: transformedPermissions };
      });
    }
    rolePermission = rolePermission.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    return rolePermission;
  }

  formatPermissions(
    parsedPermissions: ParsedPermission[],
    hits: any[]
  ): ParsedPermission[] {
    if (hits) {
      parsedPermissions = parsedPermissions.map((pp) => {
        let p = hits.find((i2) => i2.name === pp.name);
        if (p) {
          return {
            ...pp,
            ...{
              application: p.application,
              permission: p.permission,
              description: p.description,
              section: p.section,
              module: p.module ? p.module : "",
              isFirstElement: false,
            },
          };
        }
      });
    }
    parsedPermissions = parsedPermissions.filter((p) => p !== undefined);

    parsedPermissions = parsedPermissions.sort((a, b) =>
      a.module.localeCompare(b.module)
    );

    parsedPermissions = parsedPermissions.map((p, i) => {
      p.isFirstElement = i === 0;
      if (i > 0) {
        p.isFirstElement = p.module !== parsedPermissions[i - 1].module;
      }
      return { ...p };
    });

    return parsedPermissions;
  }

  mapUsers(hits: any): User[] {
    let users: User[] = [];
    if (hits) {
      users = hits.map((user) => {
        let fullName = user.lastName + ", " + user.firstName;
        if (user.middleInitial && user.middleInitial.trim()) {
          fullName = fullName + " " + user.middleInitial + ".";
        }
        // orgRoles is optional on the search document. It was dereferenced twice
        // unguarded, so ONE malformed user hit threw inside the subscribe — which
        // left the panel with loadingUsers stuck true: no rows AND no
        // "No Users Found".
        const distinctOrgs = (user.orgRoles || []).filter(
          (role, index, self) =>
            self.findIndex((r) => r.abbreviation === role.abbreviation) === index
        );
        return {
          userId: user.userId,
          locations: distinctOrgs.map((loc) => loc.abbreviation).join(", "),
          fullName: fullName,
          firstName: user.firstName,
          lastName: user.lastName,
          middleInitial: user.middleInitial,
          department: user.department,
          discipline: user.disciplines ? user.disciplines.join(", ") : "",
          tenantId: distinctOrgs.map((loc) => loc.orgId),
        } as User;
      });
    }
    return users;
  }
}



// WEBPACK FOOTER //
// ./src/providers/roles/roles.service.ts